import { gql } from "@apollo/client";

export const SendSMS = gql`
  mutation sendSMS($input: inputSendSMS!) {
    sendSMS(input: $input)
  }
`;
